import React, { FC, MouseEvent } from "react";

import { toast } from "react-toastify";

import { useBoolean } from "~/hooks";

import { AiBusinessSectionContextType } from "~/features/ai-customize/types";
import { Button } from "~/ui";
import { LabelWithTextArea, TogglablePostHeader } from "~/ui";

type PropsType = {
  aiBusinessSectionContext: AiBusinessSectionContextType;
  className?: string;
  refetch: () => void;
};

export const AiBusinessSectionContextDetail: FC<PropsType> = ({
  aiBusinessSectionContext,
  className = "",
  refetch,
}: PropsType) => {
  const { isChecked, toggle } = useBoolean(false);

  const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    toggle();
  };

  const handleDelete = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (confirm("本当に削除しますか？")) {
      // TODO: Implement delete API when available
      toast.success("削除しました");
      refetch();
    }
  };

  return (
    <div className={`${className}`}>
      <div className="space-y-6">
        <TogglablePostHeader
          avatarUrl={aiBusinessSectionContext.createdByEmployee.avatarUrl}
          employeeName={aiBusinessSectionContext.createdByEmployee.name}
          createdAt={aiBusinessSectionContext.updatedAt}
          handleToggle={handleToggle}
          isOpen={isChecked}
        />
        {isChecked && (
          <>
            <div>
              <p className="text-sm text-secondary-600 mb-2">部署・課</p>
              <p className="text-sm text-gray-700">
                {aiBusinessSectionContext.businessSection.name}
              </p>
            </div>
            <LabelWithTextArea
              labelText="AIカスタマイズ"
              name="context"
              placeholder="AIカスタマイズ"
              rows={6}
              value={aiBusinessSectionContext.context}
              disabled
            />
            <div className="flex justify-end">
              <Button
                onClick={handleDelete}
                size="sm"
                color="red"
                text="削除する"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
